import React from 'react';
import PropTypes from 'prop-types';
import { loadRazorpayScript } from '../utils/loadRazorpay';
import { shouldHideSubscriptionPurchase } from '../utils/platform';

const API_BASE = 'https://api.trackyourwheelz.com/api'; // your Laravel API URL
const FULLSCREEN_STYLE_ID = 'razorpay-fullscreen-style';

const injectFullscreenStyles = () => {
  if (document.getElementById(FULLSCREEN_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = FULLSCREEN_STYLE_ID;
  style.innerHTML = `
    body.razorpay-fullscreen-open {
      overflow: hidden !important;
    }
    body.razorpay-fullscreen-open .razorpay-container {
      position: fixed !important;
      inset: 0 !important;
      width: 100vw !important;
      height: 100vh !important;
      background: rgba(0,0,0,0.85) !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 0 !important;
      margin: 0 !important;
      border-radius: 0 !important;
      z-index: 2147483647 !important;
    }
    body.razorpay-fullscreen-open .razorpay-container iframe {
      width: 100% !important;
      height: 100% !important;
      max-width: none !important;
      max-height: none !important;
      border-radius: 0 !important;
    }
  `;
  document.head.appendChild(style);
};

const enableFullscreenMode = () => {
  injectFullscreenStyles();
  document.body.classList.add('razorpay-fullscreen-open');
};

const disableFullscreenMode = () => {
  document.body.classList.remove('razorpay-fullscreen-open');
};

const RazorpayButton = ({
  amount,
  userName = 'Test User',
  userEmail = 'test@example.com',
  userContact = '9999999999',
  invoiceId,
  label,
  buttonClassName = '',
}) => {
  if (shouldHideSubscriptionPurchase()) {
    return null;
  }

  const handlePay = async () => {
    const token = localStorage.getItem('jwtToken');
    if (!token) {
     
      return;
    }

    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      
      return;
    }

    // 1. Create order via Laravel backend
    const orderRes = await fetch(`${API_BASE}/razorpay/order`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ 
        amount,
        invoice_id: invoiceId 
      }), // rupees
    });

    if (!orderRes.ok) {
      
      return;
    }

    const orderData = await orderRes.json();

    const options = {
      key: orderData.key,
      amount: orderData.amount, // paise
      currency: orderData.currency,
      name: 'My Store',
      description: 'Test Transaction',
      order_id: orderData.orderId,
      handler: async function (response) {
        // 2. Send Razorpay response to backend for verification
        const verifyRes = await fetch(`${API_BASE}/razorpay/verify`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(response),
        });

        const verifyData = await verifyRes.json();

        if (verifyRes.ok && verifyData.status === 'success') {
         
        } else {
     
        }

        disableFullscreenMode();
      },
      prefill: {
        name: userName,
        email: userEmail,
        contact: userContact,
      },
      theme: {
        color: '#3399cc',
      },
      modal: {
        ondismiss: () => {
          disableFullscreenMode();
        },
        escape: false,
        backdropclose: false,
      },
    };

    const rzp1 = new window.Razorpay(options);
    enableFullscreenMode();
    rzp1.open();
  };

  const baseClasses = "bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors text-sm font-medium flex items-center justify-center gap-1";

  return (
    <button onClick={handlePay} className={`${baseClasses} ${buttonClassName}`.trim()}>
      {label || `Pay ₹${amount}`}
    </button>
  );
};

RazorpayButton.propTypes = {
  amount: PropTypes.number.isRequired,
  userName: PropTypes.string,
  userEmail: PropTypes.string,
  userContact: PropTypes.string,
  invoiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  buttonClassName: PropTypes.string,
};

export default RazorpayButton;